'use client'

import { Button } from '@/components/ui/button'
import { useIsMobileClient } from '@/hooks/common/use-device-type'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

interface ModalInfoX2CoolCashProps {
  onClose?: () => void
}

export const ModalInfoX2CoolCash = ({ onClose }: ModalInfoX2CoolCashProps) => {
  const t = useTranslations('product_detail.title.coolcash_modal')
  const t2 = useTranslations('button')

  const isMobile = useIsMobileClient()
  const imageSrc = isMobile
    ? '/image/April2024/mceclip2_42.png'
    : '/image/April2024/mceclip0_46.png'

  const imageSize = isMobile
    ? { width: 375, height: 400 }
    : { width: 800, height: 300 }

  return (
    <div className='no-scrollbar max-h-[80vh] w-full max-w-3xl overflow-y-auto'>
      <div className='mb-6'>
        <h2 className='text-2xl font-bold'>{t('title')}</h2>
        <p className='mt-2 text-base text-gray-600'>{t('description')}</p>
      </div>

      <div className='mt-4'>
        <Image
          src={ImageHelper.getImageUrl(imageSrc)}
          alt={t('coolcash_conversion_table')}
          width={imageSize.width}
          height={imageSize.height}
          className='w-full'
          unoptimized
          priority
        />
      </div>

      <div className='mt-4 text-sm text-gray-500'>
        * {t('coolcash_conversion_table_description')}
      </div>

      <div className='mt-2 flex flex-col items-center justify-center gap-4 rounded-2xl bg-neutral-200 p-4 text-sm'>
        <div className='text-center font-bold'>
          {t('coolcash_conversion_table_description_2')}
        </div>
        <Button className='w-full uppercase' variant={'black'}>
          {t2('join_coolclub')}
        </Button>
        <Button
          variant='outline-neutral'
          className='w-full uppercase'
          onClick={onClose}
        >
          {t2('login')}
        </Button>
      </div>
    </div>
  )
}
